export class DsTableOptions {
  allowAdding: boolean;
  allowDeleting: boolean;
  allowEditing: boolean;
  allowReset: boolean;

  showOptions: boolean;

  public customOptions?: DsTableCustomOption[];

  constructor(options: {
    allowAdding?: boolean;
    allowDeleting?: boolean;
    allowEditing?: boolean;
    allowReset?: boolean;
    showOptions?: boolean;
  }) {
    this.allowAdding = options.allowAdding == true;
    this.allowDeleting = options.allowDeleting == true;
    this.showOptions = options.showOptions == true;
    this.allowEditing = options.allowEditing == true;
    this.allowReset = options.allowReset == true;
  }
}

export class DsTableCustomOption {
  /**button/link translation key */
  public key: string;

  /**style of button */
  public styleClass: string;

  public icon: DsTableCustomOptionIcon;

  public behavior: DsTableCustomOptionBehavior;
}

export class DsTableCustomOptionBehavior {
  public clickHandler?: Function;

  public router?: DsTableCustomOptionRouter;
}

export class DsTableCustomOptionRouter {
  public link: DsTableCustomOptionRouterLink;
  public queryParams: DsTableCustomOptionRouterQueryParams;
}

export class DsTableCustomOptionRouterLink {
  public resolver: Function;
}

export class DsTableCustomOptionRouterQueryParams {
  public resolver: Function;
}

export class DsTableCustomOptionIcon {
  public styleClass: string;
}
